import { Box, Drawer } from '@mui/material'
import { useDrawerStore } from 'store'
import Contents from 'components/Dashboard/Drawer/Contents'

interface Props {
  width: number
  TOP_MARGIN_MD: string
  TOP_MARGIN_SM: string
}
export default function MobileDrawer(props: Props) {
  const { width, TOP_MARGIN_SM, TOP_MARGIN_MD } = props
  const [open, setOpen] = useDrawerStore((state) => [state.open, state.setOpen])

  return (
    <Box>
      <Drawer
        sx={{ zIndex: 1204 }}
        anchor="left"
        open={open}
        onClose={() => setOpen(false)}
        hideBackdrop={false}
        PaperProps={{
          sx: {
            '&.MuiPaper-root': {
              bgcolor: 'transparent',
              height: 'calc(100% - 78px)',
              width: '292px',
              mt: { xs: TOP_MARGIN_SM, sm: TOP_MARGIN_MD, lg: '113px' },
              border: 'none',
              boxShadow: 'none',
            },
          },
        }}
        ModalProps={{
          sx: {
            '& .MuiBackdrop-root': {
              bgcolor: 'transparent',
            },
          },
        }}
      >
        <Contents width={width} />
      </Drawer>
    </Box>
  )
}
